export const SET_SELECTED_ORDER_CARRIER = 'ORDER/SET_SELECTED_CARRIER';
export const CLEAR_ORDER = 'ORDER/CLEAR';
export const SET_SELECTED_ORDER_PAYMENT_METHOD = 'ORDER/SET_SELECTED_PAYMENT_METHOD';
export const SET_ORDER_ITEMS = 'ORDER/SET_ITEMS';
export const SET_SELECTED_ORDER_DELIVERY_ADDRESS = 'ORDER/SET_SELECTED_DELIVERY_ADDRESS';
